export const SITE_NAME = 'The Marquee';
export const SITE_DESCRIPTION = 'The definitive source for breaking entertainment news, industry business, film reviews, and celebrity coverage.';
export const SITE_TAGLINE = 'Illuminating the industry since 2009.';

export const CATEGORIES = [
  { name: 'Music', slug: 'music' },
  { name: 'Film', slug: 'film' },
  { name: 'TV', slug: 'tv' },
  { name: 'Culture', slug: 'culture' },
  { name: 'Business', slug: 'business' },
  { name: 'Awards', slug: 'awards' },
] as const;

export type CategorySlug = (typeof CATEGORIES)[number]['slug'];

export const AUTHOR_PERSONAS = [
  {
    name: 'Marcus J. Delany',
    initials: 'MD',
    title: 'Senior Music Industry Correspondent',
    bio: 'Marcus covers chart performance, artist strategy, and the global recorded music market for The Marquee. Based in Los Angeles.',
    categories: ['music', 'business'],
  },
  {
    name: 'Sofia Chen',
    initials: 'SC',
    title: 'Film & Television Editor',
    bio: 'Sofia reports on the film and streaming landscape, from box office trends to prestige TV. Based in New York.',
    categories: ['film', 'tv'],
  },
  {
    name: 'Aisha Palmer',
    initials: 'AP',
    title: 'Culture & Celebrity Reporter',
    bio: 'Aisha covers celebrity news, pop culture moments, and entertainment trends for The Marquee. Based in Miami.',
    categories: ['culture'],
  },
  {
    name: 'Ryan Kowalski',
    initials: 'RK',
    title: 'Awards & Industry Analyst',
    bio: 'Ryan tracks awards season, industry deals, and the business of entertainment. Based in Chicago.',
    categories: ['awards'],
  },
] as const;

export const TRUSTED_SOURCES = [
  'Billboard', 'Variety', 'Deadline', 'Hollywood Reporter',
  'TMZ', 'People', 'Entertainment Weekly', 'Rolling Stone',
  'AP News', 'Reuters', 'Pitchfork', 'NME',
  'The Guardian', 'New York Times', 'Los Angeles Times',
  'BBC News', 'CNN Entertainment', 'E! News', 'Us Weekly',
];

export const CATEGORY_COLORS: Record<string, { gradient: string; accent: string }> = {
  music: { gradient: '#191970', accent: '#FF00FF' },
  film: { gradient: '#0A0A1A', accent: '#00FFFF' },
  tv: { gradient: '#0D0D20', accent: '#CCFF00' },
  culture: { gradient: '#191970', accent: '#FF00FF' },
  business: { gradient: '#0A0A1A', accent: '#191970' },
  awards: { gradient: '#191970', accent: '#00FFFF' },
};

export const ARTICLES_PER_PAGE = 20;
export const MAX_ARTICLES_PER_CATEGORY_PER_DAY = 30;
export const MAX_ARTICLES_PER_SUBJECT_PER_DAY = 4;
export const DEDUP_SIMILARITY_THRESHOLD = 0.25;
export const FACT_CHECK_CONFIDENCE_THRESHOLD = 0.7;
export const PIPELINE_LOCK_TTL_MINUTES = 10;
export const CONSECUTIVE_FAILURES_ALERT_THRESHOLD = 3;
export const LOG_RETENTION_DAYS = 30;
export const ARCHIVE_AFTER_DAYS = 90;
export const ARCHIVE_MIN_VIEWS = 100;
export const IMAGE_CLEANUP_AFTER_DAYS = 120;
export const STORAGE_WARNING_PERCENT = 80;
export const STORAGE_ALERT_PERCENT = 90;
